import {
  SolutionOutlined,
  ScheduleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import { MdOutlineFamilyRestroom } from "react-icons/md";
import { RiFileHistoryLine } from "react-icons/ri";
import { GoFileDirectory } from "react-icons/go";
import { FaBriefcaseMedical } from "react-icons/fa";
import { GiMedicines } from "react-icons/gi";
import { FaFileMedicalAlt } from "react-icons/fa";
import { BsFillFileEarmarkMedicalFill } from "react-icons/bs";
import { FaNotesMedical } from "react-icons/fa";
import { BsBank } from "react-icons/bs";
import { FaIdCardAlt } from "react-icons/fa";
import { BsJournalMedical } from "react-icons/bs";
import { CiRepeat } from "react-icons/ci";
import { FiUserPlus } from "react-icons/fi";
import { FiUserMinus } from "react-icons/fi"
import { MdMessage } from "react-icons/md";
import { FaFileInvoiceDollar } from "react-icons/fa6";

export const items = [
  {
    key: "1",
    icon: <UserOutlined />,
    label: (
      <NavLink
        to="/miperfil"
        className={({ isActive }) =>
          isActive ? "menu-link active" : "menu-link"
        }
      >
        Mi Perfil
      </NavLink>
    ),
  },
  {
    key: "sub1",
    label: "Consultas",
    icon: <ScheduleOutlined />,
    children: [
      {
        key: "2",
        icon: <MdOutlineFamilyRestroom />,
        label: (
          <NavLink
            to="/nucleofamiliar"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Núcleo Familiar
          </NavLink>
        ),
      },
      {
        key: "3",
        icon: <RiFileHistoryLine />,
        label: (
          <NavLink
            to="/historicoaut"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Mis Autorizaciones
          </NavLink>
        ),
      },
      {
        key: "4",
        icon: <GoFileDirectory />,
        label: (
          <NavLink
            to="https://arsrenacer.com/directorio/"
            target="_blank"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Directorio de Prestadores
          </NavLink>
        ),
      },
      {
        key: "5",
        icon: <FaBriefcaseMedical />,
        label: (
          <NavLink
            to="/medicinadisp"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Medicamentos Disponibles
          </NavLink>
        ),
      },
      {
        key: "6",
        icon: <GiMedicines />,
        label: (
          <NavLink
            to="/coberturamedica"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Medicamentos en Cobertura
          </NavLink>
        ),
      },
      {
        key: "7",
        icon: <FaFileMedicalAlt />,
        label: (
          <NavLink
            to="/coberturaproced"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Procedimientos en Cobertura
          </NavLink>
        ),
      },
      {
        key: "8",
        icon: <BsFillFileEarmarkMedicalFill />,
        label: (
          <NavLink
            to="/preciofarmacos"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Precios de Medicamentos
          </NavLink>
        ),
      },
      {
        key: "9",
        icon: <FaNotesMedical />,
        label: (
          <NavLink
            to="/estadodecuentas"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Estado de Cuentas
          </NavLink>
        ),
      },
      {
        key: "10",
        icon: <BsBank />,
        label: (
          <NavLink
            to="/cuentasbancariasafil"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Cuentas Bancarias
          </NavLink>
        ),
      },
      /*
      {
        key: "11",
        label: (
          <NavLink
            to="/cuentasafil"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Cuentas Por Cobrar
          </NavLink>
        ),
      },
      */
    ],
  },
  {
    key: "sub2",
    label: "Solicitudes",
    icon: <SolutionOutlined />,
    children: [
      {
        key: "12",
        icon: <FaIdCardAlt />,
        label: (
          <NavLink
            to="/carnetdigital"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Mi Carnét Digital
          </NavLink>
        ),
      },
      {
        key: "13",
        icon: <BsJournalMedical />,
        label: (
          <NavLink
            to="/precertificaciones"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Pre-certificaciones
          </NavLink>
        ),
      },
      {
        key: "14",
        icon: <CiRepeat />,
        label: (
          <NavLink
            to="/Reembolso"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Reembolso
          </NavLink>
        ),
      },
      {
        key: "15",
        icon: <FiUserPlus />,
        label: (
          <NavLink
            to="/inclusiondepend"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Inclusión Dependientes
          </NavLink>
        ),
      },
      {
        key: "16",
        icon: <FiUserMinus />,
        label: (
          <NavLink
            to="/exclusiondepend"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Exclusión Dependientes
          </NavLink>
        ),
      },
      {
        key: "17",
        icon: <MdMessage />,
        label: (
          <NavLink
            to="/quejas"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Presentar Quejas
          </NavLink>
        ),
      },
      {
        key: "18",
        icon: <FaFileInvoiceDollar />,
        label: (
          <NavLink
            to="/solicitarcobrorecurrente"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            Solicitar Cobro Recurrente
          </NavLink>
        ),
      },
    ],
  },
];
